/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Quotas_Near_LimitInputs */



/**
* | output |
* | --- |
* | "Near limit" |
*
* @param {Sub_Quotas_Near_LimitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_quotas_near_limit = /** @type {((inputs?: Sub_Quotas_Near_LimitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Quotas_Near_LimitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fast am Limit")
	return /** @type {LocalizedString} */ ("Near limit")
});